module.exports = __webpack_public_path__ + "static/media/amulet_07.e68f6646.png";